export const replyCommentErrorInformation: { [id: string]: string } = {
  401: "Invalid access token. Please log back again",
  profanityContent: "Profanity in comment is not allowed",
};
